module.exports = __webpack_public_path__ + "media/images/flags/CL-ccec8be53695d08eed73dd2e16398de3.svg";